//============================================================================
// Name        : shipments_transfer_details.ts
// Purpose     : Implement shipments transfer detail page
// Created     : 2021-04-20
// Author      : Alireza Mohagheghi
// Copyright   : Copyright 2021 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";

class ShipmentsTransferDetails {
    init() {
        let resData = 0;
        let detailIds = [];
        const clientCode = $("#client_code").val();
        const store = $("#store_code").val();
        const slipId = $("#slip_id").val();

        function select_tag(ele) {
            const values = [];
            detailIds = [];
            $.each($("input[name='killTag[]']:checked"), function() {
                values.push($(this).val());
                detailIds.push($(this).data("trans"));
            });
            const path = "/" + clientCode + "/" + store + "/alerts/epc_data";
            const tableData = [];
            $.get(path, { epc_ids: values, client_code: clientCode, store_code: store }, (data, status) => {
                resData = data.data;
                $.each(resData, (k, v) => {
                    tableData.push("<tr>" +
                        "<td>" + (v[2] || "-") + "</td>" +
                        "<td>" + (v[6] || "-") + "</td>" +
                        "<td>" + (v[1] || "-") + "</td>" +
                        "<td>" + (v[3] || "-") + "</td>" +
                        "<td class='text-center'><span class='label label-pending-gray line-height-28'>Pending</span></td>" +
                        "</tr>");
                });
                $("#count_epcs").html(data.count);
                $("#kill-tag").html(tableData.join(""));
            });
        }

        function change_status() {
            const reasonVal = $("#reason").val();
            const killPath =  "/" + clientCode + "/" + store + "/alerts/kill_tag";
            $.post(killPath, { epc_data: resData, reason: reasonVal, client_code: clientCode, store_code: store, alert: detailIds, slip_id: slipId }, (data, status) => {
                window.location.href = window.location.href;
            });
        }

        $(() => {
            $("#kill-select-btn").click(select_tag);
        });
        $(() => {
            $("button.kill").click(change_status);
        });
    }
}

export function LoadPage() {
    InitPage("transfer_details", () => {
        const shipmentsTransferDetails = new ShipmentsTransferDetails();
        shipmentsTransferDetails.init();
    });
}
